import {invalidateQueries, q} from "../../state";
import {CreateThirdPartyTier, ThirdPartyTierId, ThirdPartyTierMin} from "platformed-client/types";
import {platformedClient} from "..";

export async function list(): Promise<ThirdPartyTierMin[]> {
  return await platformedClient.internalRequest("get", "/region/{region}/api/tprm/third_party_tiers", {});
}

export async function create(tier: CreateThirdPartyTier) {
  const res = await platformedClient.internalRequest("post", "/region/{region}/api/tprm/third_party_tiers", {
    body: tier,
  });
  await invalidateQueries([q.tprm.thirdPartyTiers.filter()]);
  return res;
}

export async function updateTitle(tierId: ThirdPartyTierId, title: string) {
  const res = await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/tprm/third_party_tiers/{tier_id}/title",
    {path: {tier_id: tierId}, body: title},
  );
  await invalidateQueries([q.tprm.thirdPartyTiers.filter()]);
  return res;
}

export async function updateColor(tierId: ThirdPartyTierId, color: string) {
  const res = await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/tprm/third_party_tiers/{tier_id}/color",
    {path: {tier_id: tierId}, body: color},
  );
  await invalidateQueries([q.tprm.thirdPartyTiers.filter()]);
  return res;
}

export async function reorder(tierId: ThirdPartyTierId, ordinal: number) {
  const res = await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/tprm/third_party_tiers/{tier_id}/ordinal",
    {path: {tier_id: tierId}, body: ordinal},
  );
  await invalidateQueries([q.tprm.thirdPartyTiers.filter()]);
  return res;
}

export async function delete_(tierId: ThirdPartyTierId) {
  const res = await platformedClient.internalRequest(
    "delete",
    "/region/{region}/api/tprm/third_party_tiers/{tier_id}",
    {path: {tier_id: tierId}},
  );
  await invalidateQueries([q.tprm.thirdPartyTiers.filter()]);
  return res;
}
